import { OPS_METRICS_TYPES } from "@amzn/asx-ui-telemetry-client";
import React from "react";

import { LABELS } from "../../../constants/common";
import {
    CLOUDWATCH_RUM_COUNTERS,
    TELEMETRY_ID,
} from "../../../constants/telemetry";
import {
    logWithAsxTelemetryClient,
    logWithTakt,
} from "../../../utils/telemetry.utils";

import {
    StyledErrorBoundaryCard,
    StyledErrorBoundaryContainer,
    StyledErrorBoundaryText,
} from "./ErrorBoundaryStyles";

interface ErrorBoundaryState {
    error: string;
}

interface ErrorBoundaryProps {
    children: React.ReactNode;
}

export class ErrorBoundary extends React.Component<
    ErrorBoundaryProps,
    ErrorBoundaryState
> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { error: "" };
    }

    static getDerivedStateFromError(error: Error): {
        error: string;
    } {
        // Update state so the next render will show the fallback UI.
        return { error: error.message };
    }

    componentDidCatch(error: Error): void {
        logWithTakt(TELEMETRY_ID.DISCOVERY_ERROR_PAGE, {
            errorMessage: error.message,
        });
        logWithAsxTelemetryClient(
            CLOUDWATCH_RUM_COUNTERS.UNHANDLED_CLIENT_ERROR_BOUNDARY,
            OPS_METRICS_TYPES.Error,
            1,
            {
                errorMessage: error.message,
            },
        );
    }

    render(): JSX.Element | React.ReactNode {
        const { children } = this.props;
        const { error } = this.state;

        if (error) {
            return (
                <StyledErrorBoundaryContainer justifyContent="center">
                    <StyledErrorBoundaryCard>
                        <StyledErrorBoundaryText renderAs="h2">
                            {LABELS.WHOOPS_SOMETHING_WENT_WRONG}
                        </StyledErrorBoundaryText>
                        <StyledErrorBoundaryText renderAs="h4">
                            {LABELS.REFRESH_OR_TRY_AGAIN_LATER}
                        </StyledErrorBoundaryText>
                    </StyledErrorBoundaryCard>
                </StyledErrorBoundaryContainer>
            );
        }

        return children;
    }
}
